import { render, staticRenderFns } from "./UserManual.vue?vue&type=template&id=74b538ef&scoped=true"
import script from "./UserManual.vue?vue&type=script&lang=js"
export * from "./UserManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b538ef",
  null
  
)

export default component.exports